import { PieChart, Pie, Cell, Tooltip } from "recharts";
import React, { useEffect, useState } from "react";
import { useLazyGetTechItemsQuery } from "../../../../services/Api";
import LoaderSpiner from "../../../../components/loaderSpiner";

const COLORS = ["#3D5673", "#5D733C", "#FFB14E", "#A192FA", "#F2C94C"];

export default function ToiletryDistribution() {
  const [trigger, { data, isLoading, error }] = useLazyGetTechItemsQuery();
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    trigger()
      .unwrap()
      .then((response) => {
        const packingStats = response?.data || [];
        const formattedData = packingStats.map((item) => ({
          name: item.label,
          value: parseFloat(item.percentage),
        }));
        setChartData(formattedData);
      })
      .catch((err) => {
        // console.error("Error fetching data:", err);
      });

  }, [trigger]);

  if (isLoading) return <LoaderSpiner />;
  if (error) return <p>Error loading data. Please try again later.</p>;

  return (
    <div className="bg-lightgreen p-6 rounded-[1.75rem] h-full">
      <h3 className="mb-4 font-['Roboto_Mono'] text-lg font-bold">
        Tech Items By Percentage
      </h3>
      <div className="flex flex-col justify-center items-center relative">
        {/* Pie Chart */}
        <div className="relative flex justify-center items-center w-full sm:w-[200px] md:w-[250px]">
          <PieChart width={200} height={200}>
            <Pie
              data={chartData}
              innerRadius={60}
              outerRadius={80}
              paddingAngle={0}
              dataKey="value"
            >
              {chartData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip
              wrapperStyle={{
                fontSize: "14px",
                backgroundColor: "#000",
                color: "#fff",
              }}
              formatter={(value) => `${value}%`}
            />
          </PieChart>
          <div className="absolute flex flex-col justify-center items-center top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <p className="text-2xl font-bold">100%</p>
          </div>
        </div>

        {/* Legend Section */}
        <div className="w-full sm:w-auto flex flex-col justify-center gap-4 mt-4 md:mt-0 pr-8 md:pr-0">
          <div className="grid grid-cols-1 md:grid-cols-1">
            {chartData.map((entry, index) => (
              <div
                key={entry?.name}
                className="flex items-center gap-2 whitespace-nowrap"
              >
                <div
                  className="w-2 h-2 rounded-full shrink-0"
                  style={{ backgroundColor: COLORS[index % COLORS.length] }}
                ></div>
                <span className="md:text-sm text xs">{entry?.name}</span>
                <span className="text-xs md:text-sm">{entry?.value}%</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
